import { createSelector, createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,
  blockContent: {
    items: [],
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  blockDesign: {
    view: 'feed',
    layout: '1',
  },
  itemDesign: {},
  containerDesign: {},
};

export const overviewSlice = createSlice({
  name: 'overview',
  initialState,
  reducers: {
    overviewStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;
      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.itemDesign = itemDesign ?? {};
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        items: blockContent.items ?? [],
        heading: {
          title: blockContent.heading?.title ?? '',
          description: blockContent.heading?.description ?? '',
          textAlign: blockContent.heading?.textAlign ?? 'left',
          image: blockContent.heading?.image ?? '',
          divider: blockContent.heading?.divider ?? '',
          position: blockContent.heading?.position ?? '',
        },
      };

      state.blockDesign = {
        view: blockDesign.view ?? 'feed',
        layout: blockDesign.layout ?? '1',
      };
    },
    overviewClear: () => initialState,
    overviewUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    overviewUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    overviewUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    overviewUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
  },
});

export const { overviewStore, overviewClear, overviewUpdateIsLoading, overviewUpdateIsActive, overviewUpdateBlockContent, overviewUpdateBlockDesign } = overviewSlice.actions;

export const selectOverviewIsLoading = (state) => state.overview.isLoading;
export const selectOverviewId = (state) => state.overview.id;
export const selectOverviewUID = (state) => state.overview.uid;
export const selectOverviewSID = (state) => state.overview.sid;
export const selectOverviewBlockContent = (state) => state.overview.blockContent;
export const selectOverviewBlockDesign = (state) => state.overview.blockDesign;
export const selectOverviewSortItems = createSelector([selectOverviewBlockContent], ({ items }) => items ?? []);
export const selectOverviewItemDesign = (state) => state.overview.itemDesign;
export const selectOverviewContainerDesign = (state) => state.overview.containerDesign;

export default overviewSlice.reducer;
